import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
  if (!$('.table-text').length) {
    return;
  }

  if ($(window).width() <= 768) {
    tabletextSliderMobile($);
  }
});


function tabletextSliderMobile($) {
  $('.table tbody').addClass('swiper-wrapper');
  new Swiper('.table', {
    spaceBetween: 20,
    slidesPerView: 1,
    lopp: true,
    navigation: {
      prevEl: '.table-text-prev-button',
      nextEl: '.table-text-next-button',
    },
  });
}


// WEBPACK FOOTER //
// ./scripts/blocks/table-text.js